import { Box, FlexColumn, SingleSelect } from "designSystem/index";
import { observer } from "mobx-react-lite";
import React, { FunctionComponent } from "react";
import SecondaryDisplayCustomViewOptionsStore from "src/Merchandising/SecondaryDisplay/SecondaryDisplayCustomViewOptionsStore";
import { useCustomViewDialogStore } from "../../csi/middleware/customView/CustomViewDialogStore";
import css from "../../csi/middleware/customView/options/CustomViewOptions.module.css";

const SecondaryDisplayOptions: FunctionComponent = observer(function SecondaryDisplayOptions() {
	const { optionsStore } = useCustomViewDialogStore();

	const {
		onChangeSecondaryDisplayType,
		secondaryDisplayDropDownOptions,
		selectedSecondaryDisplayType,
	} = optionsStore as SecondaryDisplayCustomViewOptionsStore;

	return (
		<Box className={css.container}>
			<FlexColumn className={css.optionLeft}>
				<SingleSelect
					disableClearable
					fullWidth
					labelRes="CustomViewSecondaryDisplayType"
					onChange={onChangeSecondaryDisplayType}
					options={secondaryDisplayDropDownOptions.secondaryDisplayTypeOptions}
					value={selectedSecondaryDisplayType}
				/>
			</FlexColumn>
		</Box>
	);
});

export default SecondaryDisplayOptions;